import {
  METRIX_START,
  METRIX_END,
  METRIX_DATA,
  METRIX_BY_ID,
  TYPE_CONFIG_DATA,
  TYPE_CONFIG_DATA_ID,
  METRICS_CALCULATION,
  CCCM_CALC_ANALYSIS_RESULTS_SUCCESS,
  CCPC_CALC_ANALYSIS_RESULTS_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

export const CompilanceTypes = (type, data) => {
  return { type, data };
};

export const runCommitmentMetricsCalculationSimulation = (data, apiPath) => {
  return async (dispatch) => {
    dispatch(CompilanceTypes(METRIX_START));
    try {
      const response = await runCommitmentMetricsCalculationSimulationAPI(data, apiPath);
      dispatch(CompilanceTypes(METRIX_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (response.data.result && response.data.result.length > 0) {
          dispatch(CompilanceTypes(METRICS_CALCULATION, response.data));
          history.push('/commitment-metrics-calculation-simulation/results');
        }
        return { success: !hasError, response };
      } else {
        if (response.data.result && response.data.result.length > 0) {
          dispatch(CompilanceTypes(METRICS_CALCULATION, response.data));
          history.push('/commitment-metrics-calculation-simulation/results');
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(CompilanceTypes(METRIX_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

const runCommitmentMetricsCalculationSimulationAPI = (data, apiPath) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post(apiPath, data, { headers });
};
export const getContractItem = (id, metricCategory, isPendingContract) => {
  return (dispatch) => {
    dispatch(CompilanceTypes(METRIX_START))
    getContractItemAPI(id, metricCategory, isPendingContract)
      .then((response) => {

        dispatch(CompilanceTypes(METRIX_BY_ID, response.data.response));

        dispatch(CompilanceTypes(METRIX_END))

      })
      .catch((error) => { dispatch(CompilanceTypes(METRIX_END)) });
  };
};

const getContractItemAPI = (id, metricCategory, isPendingContract) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const baseAPI = metricCategory === 'price_compliance_metrics'
    ? '/price-compliance/contract/'
    : '/commitment/contract/';
  const url = isPendingContract ? `${baseAPI}${id}?is_pending_contract=true` : `${baseAPI}${id}`;
  const result = axios.get(url, {
    headers: headers
  });
  return result;
};

export const deleteContractItem = (id, metricCategory) => {
  return async (dispatch) => {
    dispatch(CompilanceTypes(METRIX_START));
    try {
      const response = await deleteContractItemAPI(id, metricCategory);
      dispatch(CompilanceTypes(METRIX_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || 'Deleted successfully');
        return { success: true, response };
      }
    } catch (error) {
      dispatch(CompilanceTypes(METRIX_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
      }
      throw error;
    }
  };
};

const deleteContractItemAPI = (id, metricCategory) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const baseAPI = metricCategory === 'price_compliance_metrics'
    ? '/price-compliance/contract/'
    : '/commitment/contract/';
  const result = axios.delete(`${baseAPI}${id}`, {
    headers: headers
  });
  return result;
};

export const submitComplianceMetrics = (type, id, data, metricCategory) => {
  return async (dispatch) => {
    dispatch(CompilanceTypes(METRIX_START));
    try {
      const response = await submitComplianceMetricsAPI(type, id, data, metricCategory);
      dispatch(CompilanceTypes(METRIX_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(CompilanceTypes(METRIX_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError };
      }
      throw error;
    }
  };
};

const submitComplianceMetricsAPI = (type, id, data, metricCategory) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  const baseAPI = metricCategory === 'price_compliance_metrics' ? '/price-compliance/contract' : '/commitment/contract';
  if (type == 'edit') {
    result = axios.put(baseAPI, data, { headers: headers });
  }
  else {
    result = axios.post(baseAPI, data, { headers: headers });
  }
  return result;
};

// commitment type config
export const getCommitmentTypeConfig = (id, param) => {
  return (dispatch) => {
    dispatch(CompilanceTypes(METRIX_START))
    getCommitmentTypeConfigAPI(id, param)
      .then((response) => {

        if (id || param)
          dispatch(CompilanceTypes(TYPE_CONFIG_DATA_ID, response.data.response));
        else {
          dispatch(CompilanceTypes(TYPE_CONFIG_DATA, response.data.response));

        }
        dispatch(CompilanceTypes(METRIX_END))

      })
      .catch((error) => { dispatch(CompilanceTypes(METRIX_END)) });
  };
};

const getCommitmentTypeConfigAPI = (id, param) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id)
    result = axios.get('/config/compliance-type/' + id, { headers: headers },);
  else if (param)
    result = axios.get('/config/compliance-type', { headers: headers, params: param },);
  else
    result = axios.get('/config/compliance-type', { headers: headers },);
  return result;
};

// Not dispatched into redux state — the caller awaits the return value directly.
export const getCommitmentCalendarPeriod = (name, date) => {
  return async (dispatch) => {
    try {
      const response = await getCommitmentCalendarPeriodAPI(name, date);
      return response?.data?.response || null;
    } catch (error) {
      return null;
    }
  };
};

const getCommitmentCalendarPeriodAPI = (name, date) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get('/calendar/periods/by-date', {
    headers,
    params: { name, date },
  });
};

export const submitCommitmentTypeConfig = (type, id, data) => {
  return (dispatch) => {
    dispatch(CompilanceTypes(METRIX_START))
    submitCommitmentTypeConfigAPI(type, id, data)
      .then((response) => {
        console.log("testtt", type)
        if (type !== 'delete') {
          const redirectPath =
            data?.functionality === 'Price Contract'
              ? '/price-compliance-config-list'
              : '/commitment-config-list';
          history.push(redirectPath);
        }
        dispatch(getCommitmentTypeConfig());

        globalToast.showSuccess(response.data.message);
        dispatch(CompilanceTypes(METRIX_END))
      })
      .catch((error) => { dispatch(CompilanceTypes(METRIX_END)) });
  };
};

const submitCommitmentTypeConfigAPI = (type, id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'edit') {
    result = axios.put('/config/compliance-type/' + id, data, { headers: headers });
  }
  else if (type == 'delete') {
    result = axios.delete('/config/compliance-type/' + id, { headers: headers });
  }
  else {
    result = axios.post('/config/compliance-type', data, { headers: headers });
  }
  return result;
};

const runCalculationAnalysisAPI = (data, apiPath) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.post(apiPath, data, { headers });
};

export const runCommitmentMetricsCalculationAnalysis = (data, apiPath) => {
  return async (dispatch) => {
    dispatch(CompilanceTypes(METRIX_START));
    try {
      const response = await runCalculationAnalysisAPI(data, apiPath);
      dispatch(CompilanceTypes(METRIX_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (response.data.response && response.data.response.length > 0) {
          dispatch(CompilanceTypes(CCCM_CALC_ANALYSIS_RESULTS_SUCCESS, response.data.response));
          history.push('/commitment-metrics-calculation-analysis/results');
        }
        return { success: !hasError, response };
      } else {
        if (response.data.response && response.data.response.length > 0) {
          dispatch(CompilanceTypes(CCCM_CALC_ANALYSIS_RESULTS_SUCCESS, response.data.response));
          history.push('/commitment-metrics-calculation-analysis/results');
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(CompilanceTypes(METRIX_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

export const runPriceComplianceCalculationAnalysis = (data, apiPath) => {
  return async (dispatch) => {
    dispatch(CompilanceTypes(METRIX_START));
    try {
      const response = await runCalculationAnalysisAPI(data, apiPath);
      dispatch(CompilanceTypes(METRIX_END));
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        if (response.data.response && response.data.response.length > 0) {
          dispatch(CompilanceTypes(CCPC_CALC_ANALYSIS_RESULTS_SUCCESS, response.data.response));
          history.push('/price-compliance-calculation-analysis/results');
        }
        return { success: !hasError, response };
      } else {
        if (response.data.response && response.data.response.length > 0) {
          dispatch(CompilanceTypes(CCPC_CALC_ANALYSIS_RESULTS_SUCCESS, response.data.response));
          history.push('/price-compliance-calculation-analysis/results');
        } else {
          globalToast.showWarning('No records found.');
        }
        return { success: true, response };
      }
    } catch (error) {
      dispatch(CompilanceTypes(METRIX_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response: error.response };
      }
      throw error;
    }
  };
};

